import type { DashboardConfig } from '../config';
import { clusterBase } from '../clusterBase';

export const franceConfig: DashboardConfig = {
  path: '/carrefour/france',
  reportId: 'carrefour-france-world-cup',
  label: 'Carrefour France',
  apiBaseUrl: clusterBase('eu'),
  endsOn: '2026-07-22', // World Cup, 26 May → 22 Jul — archived from the day after
  frozen: true, // pipeline retired — the frozen payload must never be regenerated
  hide: {
    revenue: true,
    avgBasket: true,
    usersTraffic: true,
    itemsPerTx: true,
    topPrizes: true,
  },
  segmentsLocation: 'overview',
  hasExport: true,
};
